<template>
	<article class="contactus">
		<h1>Let's Work Together</h1>
		<div class="content">
			<!--<h3><span class="glyphicon glyphicon-chevron-right"></span> Let's Work Together</h3>-->
			<p>We look forward to hearing from you</p>
			<ul class="media-list contactus-list">
				<li class="media media-success">
					<div class="media-left">
						<a href="tel:+972525865589" class="btn btn-success btn-circle">
							<img class="media-object img-circle" src="static/images/icons/mobileW.png" alt="phone"/>
						</a>
					</div>
					<div class="media-body">
						<h4 class="media-heading">Reach us by phone</h4>
						<a href="tel:+972525865589">(972) 52-5865589</a>
					</div>
				</li>
				<li class="media media-success">
					<div class="media-left">
						<a href="mailto:info@weboko.co.il" class="btn btn-success btn-circle">
							<img class="media-object img-circle" src="static/images/icons/emailW.png" alt="email"/>
						</a>
					</div>
					<div class="media-body">
						<h4 class="media-heading">Write us an e-mail</h4>
						<a href="mailto:info@weboko.co.il">info@weboko.co.il</a>
					</div>
				</li>
				<li class="media media-success">
					<div class="media-left">
						<a href="mailto:info@weboko.co.il" class="btn btn-success btn-circle">
							<img class="media-object img-circle" src="static/images/icons/chatW.png" alt="email"/>
						</a>
					</div>
					<div class="media-body">
						<h4 class="media-heading">Fill out form</h4>
						<div class="contact-form"  v-if="!mail.thankyou">
							<!--<iframe src="https://www-weboko-f1a8.restdb.io/webform"></iframe>-->
							<div class="form-group">
								<input v-model="mail.name" class="form-control" name="name" data-type="text" type="text" placeholder="Name" required>
							</div>
							<div class="form-group">
								<input v-model="mail.phone" class="form-control" name="phone" data-type="text" type="text" placeholder="Phone" required>
							</div>
							<div class="form-group">
								<input v-model="mail.email" class="form-control" name="email" data-type="email" type="email" placeholder="Email">
							</div>
							<div class="form-group">
								<textarea v-model="mail.message" class="form-control" name="input" data-type="text" type="text" placeholder="Message"></textarea>
							</div>
							<button  @click="submitForm" class="btn btn-primary" id="btn-submit">Submit</button>
						</div>
						<div class="thankyou" v-if="mail.thankyou">
							Thank you!<br/>
							Your message has been successfully sent. We will contact you very soon!
						</div>
					</div>
				</li>
			</ul>
		</div>

	</article>
</template>

<script>
	export default {
		name: 'contactUs',

		methods: {
		    submitForm () {
				let body = `<h1>Weboko</h1>
					<table cellspacing="0" cellpadding="5" border="1">
						<tr><td><strong>Sender</strong></td><td>${this.mail.name}</td></tr>
						<tr><td><strong>Phone</strong></td><td>${this.mail.phone}</td></tr>
						<tr><td><strong>Email</strong></td><td>${this.mail.email}</td></tr>
						<tr><td><strong>Sender</strong></td><td>${this.mail.name}</td></tr>
						<tr><td><strong>Message</strong></td><td>${this.mail.message}</td></tr>
					</table>`;
				let mail = {
			  		'to': this.mail.to,
					'subject': 'Weboko-form',
					'sendername': this.mail.name,
					'html': body
				};
		        this.$http.post('https://weboko-f1a8.restdb.io/mail', JSON.stringify(mail), {
					'crossDomain': true,
		            headers: {
						'x-apikey': '58a99c61f1f38218353a09d4',
						'content-type': 'application/json',
						'cache-control': 'no-cache'
				   }
				}).then(data => {
					this.mail.error = false;
		            this.mail.thankyou = true;
					console.log('Contact data: ', data);
				}, err => {
		            this.mail.error = true;
					setTimeout(() => {
						this.mail.error = false;
					}, this.mail.errorDelay);
					console.log('Contact error: ', err);
				});
			}
		},

		data () {
			return {
			    mail: {
			        to: 'info@weboko.co.il',
					name: '',
					phone: '',
					message: '',
					thankyou: false,
					error: false,
					errorDelay: 10000
				}
			}
		}
	}

</script>

<style scoped>
	.contact-form iframe { width:100%; min-height:290px; border:none; }
</style>



// WEBPACK FOOTER //
// contactus.vue?07111ede